import api from "./app/api";

const getLicenseInfo = () => {
  return api.get("/license/get-license.php");
};

const importLicense = (payload: any) => {
  if (!payload) {
    return Promise.reject("payload is required");
  }
  let formData = new FormData();
  formData.append("file", payload?.selectedFile);

  return api.post("/license/import-license.php", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// ✅ New API call to back up current DB to Initial
const backupToInitial = () => {
  return api.post("/database/initialDatabase.php");
};

const addLicenseLog = (payload: any) => {
  return api.post("/license_logs/addLicenseLog.php", payload);
};

const addSoftwareLog = (payload: any) => {
  return api.post("/software_logs/addSoftwareLog.php", payload);
};

const addAuditFailureLog = (payload: any) => {
  return api.post("/audit_failure_logs/addAuditFailureLog.php", payload);
};

const CommonApi = {
  getLicenseInfo,
  importLicense,
  backupToInitial,
  addLicenseLog,
  addSoftwareLog,
  addAuditFailureLog
};
export default CommonApi;
